export default "__VITE_ASSET__rRpz4aCT__"